import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import * as LucideIcons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/lib/constants";
import Seo from "@/components/Seo";
import CTABand from "@/components/sections/CTABand";

export default function Services() {
  return (
    <div data-testid="services-page">
      <Seo
        title="Services numériques"
        description="Création de sites web, SEO local, publicité Google/Meta, automatisation IA et développement d'applications sur mesure pour PME à Montréal."
        path="/services"
      />
      <section className="bg-white pt-16 pb-12">
        <div className="mx-auto max-w-7xl px-6 md:px-10">
          <div className="text-[#00B8D9] text-xs tracking-[0.2em] uppercase font-bold mb-3">Nos services</div>
          <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl text-[#0B1F3A] tracking-tighter max-w-3xl text-balance">
            Des solutions numériques <span className="text-[#00B8D9]">complètes</span> pour PME
          </h1>
          <p className="mt-5 text-lg text-[#4B5563] max-w-2xl">
            De la création de site web à l'automatisation IA, nous couvrons toute la chaîne de croissance numérique.
          </p>
        </div>
      </section>

      <section className="bg-[#F5F7FA] py-16">
        <div className="mx-auto max-w-7xl px-6 md:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = LucideIcons[s.icon] || LucideIcons.Sparkles;
            return (
              <motion.div key={s.slug} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.06 }}>
                <Link to={`/services/${s.slug}`} data-testid={`service-card-${s.slug}`} className="group block h-full bg-white border border-gray-200 rounded-2xl p-7 hover:border-[#00B8D9] hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
                  <div className="h-12 w-12 rounded-lg bg-[#00B8D9]/10 group-hover:bg-[#00B8D9] flex items-center justify-center mb-5 transition-colors">
                    <Icon className="h-6 w-6 text-[#00B8D9] group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="font-heading font-bold text-xl text-[#0B1F3A] mb-2">{s.title}</h3>
                  <p className="text-sm text-[#4B5563] mb-4">{s.short}</p>
                  <div className="text-sm font-semibold text-[#00B8D9] flex items-center gap-1 group-hover:gap-2 transition-all">
                    Découvrir <ArrowRight className="h-4 w-4" />
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
